import Text from "../../text/Text";
import type { ImageOption } from "../../../types/Menu";
import SelectImage from "../SelectImage";

const ImageSelectValue = (props: Omit<ImageOption<null>, "value">) => (
  <div class="flex min-w-0 items-center gap-x-1.5 select-none">
    <SelectImage {...props.image} size="sm" />
    <Text as="span" truncate text={props.label} class="text-base-medium text-primary group-disabled:text-disabled" />
  </div>
);

export default ImageSelectValue;
